import React, { useState } from "react";
import Card from "components/card";
import { MdDownload } from "react-icons/md";
import { storage } from "services/firebase";
import { ref, getDownloadURL } from "firebase/storage";

export default function Download() {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const apkRef = ref(storage, "sistema/appReleases/ControlFoods.apk");
      const url = await getDownloadURL(apkRef);
      
      window.open(url, "_blank");
    } catch (error) {
      console.error("Erro ao gerar link de download:", error);
      alert("Não foi possível acessar o arquivo. Verifique se ele está disponível no servidor.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Card extra={"w-full h-full p-4"}>
      <div className="mb-8 w-full">
        <h4 className="text-xl font-bold text-navy-700">
          Aplicativo Mobile
        </h4>
      </div>

      <div className="flex flex-col items-center justify-center h-full text-gray-500 mb-8">
        <div className="mt-2 flex items-center justify-center rounded-full bg-lightPrimary p-[26px] text-5xl font-bold text-[#CF4949]">
          <MdDownload />
        </div>
        <h3 className="text-xl font-bold text-navy-700 my-3">ControlFood App</h3>
        <p className="text-center text-sm text-gray-600 px-4 mb-6">
          Instale o aplicativo nos seus dispositivos para iniciar a operação.
        </p>

        <button
          onClick={handleDownload}
          disabled={isDownloading}
          className="flex items-center gap-2 rounded-full bg-[#CF4949] px-6 py-3 font-bold text-white transition duration-200 hover:bg-[#B84343] active:bg-[#B84343] shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          <MdDownload className="text-xl" />
          {isDownloading ? "Gerando link..." : "Baixar Arquivo (.apk)"}
        </button>
      </div>
    </Card>
  );
}
